import React, { ForwardedRef, forwardRef } from 'react'
import {
  ITextInputElementProps,
  TextInputElement,
} from 'shared/ui/Input/TextInput/TextInputElement'
import { BaseInput, IBaseInputProps } from 'shared/ui/Input/BaseInput/BaseInput'

type ITextInputProps = Omit<IBaseInputProps, 'InputComponent'> &
  ITextInputElementProps

export const TextInput = forwardRef(function BaseInputRef(
  props: ITextInputProps,
  ref: ForwardedRef<HTMLLabelElement>
) {
  return (
    <BaseInput
      ref={ref}
      InputComponent={TextInputElement}
      placeholder={props.placeholder || 'Enter value'}
      {...props}
    />
  )
})
